import React from "react";
import CallToAction from "../base/CallToAction";


const Rejected = () => {
  return (
    <CallToAction title="Proceso no exitoso 😥" subtitle={<div>Desafortunadamente no pudimos completar tu proceso de verificación. Si requieres información o ayuda adicional <span className="text-Secondary cursor-pointer" onClick={() => {
        window.open(
          "https://api.whatsapp.com/send?phone=+525611225650&text=Necesito ayuda para verificar mi cuenta en FIADO.",
          "_blank"
        );
        //window.open('https://api.whatsapp.com/send?phone=+17547045658&text=FiadoDemo1','_blank');
      }}> puedes contactarnos por aquí.</span></div>} 
          />  
  );
};

export default Rejected;
